import { useLayoutEffect, useState } from 'react';

/**
 * The content width of an element, kept current with a ResizeObserver.
 *
 * Dashboard sections lay out by their own width rather than the viewport's: the docked
 * chat panel leaves a phone-wide column on a tablet. Returns [ref, width]; width is 0
 * until measured (and in environments without layout, such as tests).
 */
const useElementWidth = () => {
  const [node, setNode] = useState(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (!node) return undefined;
    setWidth(Math.round(node.getBoundingClientRect().width));
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry]) => setWidth(Math.round(entry.contentRect.width)));
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);

  return [setNode, width];
};

export default useElementWidth;
